import AuditSectionStats from "const/AuditSections";
import AuditSubsectionRoutes from "const/AuditSubsectionRoutes";

const AUDIT_TRANSACTIONS_ROUTE = "transactions";

const AUDIT_TRANSACTIONS_ALL_CATEGORIZED = {
  nameLangId: "allCategorized",
  route: AuditSubsectionRoutes.ALL_CATEGORIZED,
  statProp: AuditSectionStats.ALL_CATEGORIZED
};

const XERO_EXCLUDED_SECTIONS = [AuditSectionStats.NO_LOCATION, AuditSectionStats.NO_PROJECT];

const AuditSections = [
  {
    nameLangId: "transactions",
    route: AUDIT_TRANSACTIONS_ROUTE,
    items: [
      AUDIT_TRANSACTIONS_ALL_CATEGORIZED,
      {
        nameLangId: "withoutPayee",
        route: AuditSubsectionRoutes.NO_PAYEE,
        statProp: AuditSectionStats.NO_PAYEE
      },
      {
        nameLangId: "withoutClass",
        route: AuditSubsectionRoutes.NO_CLASS,
        statProp: AuditSectionStats.NO_CLASS
      },
      {
        nameLangId: "withoutLocation",
        route: AuditSubsectionRoutes.NO_LOCATION,
        statProp: AuditSectionStats.NO_LOCATION
      },
      {
        nameLangId: "withoutProject",
        route: AuditSubsectionRoutes.NO_PROJECT,
        statProp: AuditSectionStats.NO_PROJECT
      },
      {
        nameLangId: "amountDeviation",
        route: AuditSubsectionRoutes.AMOUNT_DEVIATION,
        statProp: AuditSectionStats.AMOUNT_DEVIATION
      },
      {
        nameLangId: "duplicateEntries",
        route: AuditSubsectionRoutes.DUPLICATES,
        statProp: AuditSectionStats.DUPLICATES
      },
      {
        nameLangId: "similarPayees",
        route: AuditSubsectionRoutes.SIMILAR_PAYEE,
        statProp: AuditSectionStats.SIMILAR_PAYEE
      },
      {
        nameLangId: "postedToParentGL",
        route: AuditSubsectionRoutes.POSTED_TO_PARENT,
        statProp: AuditSectionStats.POSTED_TO_PARENT
      },
      {
        nameLangId: "unusualCategory",
        route: AuditSubsectionRoutes.UNUSUAL_CATEGORY,
        statProp: AuditSectionStats.UNUSUAL_CATEGORY
      },
      {
        nameLangId: "unusualAmount",
        route: AuditSubsectionRoutes.UNUSUAL_AMOUNT,
        statProp: AuditSectionStats.UNUSUAL_AMOUNT
      },
      {
        nameLangId: "unusualTax",
        route: AuditSubsectionRoutes.UNUSUAL_TAX,
        statProp: AuditSectionStats.UNUSUAL_TAX
      },
      {
        nameLangId: "withoutAttachment",
        route: AuditSubsectionRoutes.NO_ATTACHMENT,
        statProp: AuditSectionStats.NO_ATTACHMENT
      }
    ]
  }
];

export default AuditSections;

export { AUDIT_TRANSACTIONS_ALL_CATEGORIZED, AUDIT_TRANSACTIONS_ROUTE, XERO_EXCLUDED_SECTIONS };
